import React, { useState } from "react";

//router
import { Link, useHistory } from "react-router-dom";

//components
import {
  Avatar,
  Button,
  Menu,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import useFetch from "../../Hooks/useFetch";
//styles
import useStyles from "./navbarStyles";

//redux
import { useSelector, useDispatch } from "react-redux";
import {
  setUserToState,
  setAuthToState,
  selectAuth,
  logout,
} from "../../features/auth/authSlice";

//hooks
import useModal from "../../Hooks/useModal";

function Navbar() {
  const dispatch = useDispatch();
  const history = useHistory();
  const auth = useSelector(selectAuth);

  const { data } = useFetch();
  const myProjects = data?.items.filter(
    (item) => item.fields.slug === "project"
  );
  console.log(myProjects, "myProjects");
  const Project = data?.items.findIndex((item, index) => {
    if (item.sys.id === "10e6LFVI05dL75rTFRGJ0Z") {
      return item;
    }
  });

  const Project2 = data?.items.findIndex((item, index) => {
    if (item.sys.id === "38vNF32PbWvTncVDS5N0UW") {
      return item;
    }
  });

  const Project3 = data?.items.findIndex((item, index) => {
    if (item.sys.id === "7sjCFRBSwFDf2tT1nuSruk") {
      return item;
    }
  });

  console.log(Project);
  // console.log(data)

  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")));
  const [anchorEl, setAnchorEl] = React.useState(null);

  const { handleShow, handleClose, open } = useModal();

  const setAuth = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const auth = JSON.parse(localStorage.getItem("auth"));
    if (auth) {
      dispatch(setUserToState(user.data));
      dispatch(setAuthToState(auth));
    }
  };

  React.useEffect(() => {
    setAuth();
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  //JSON.parse(localStorage.getItem("profile")));
  const logout = () => {
    // dispatch({ type: actionType.LOGOUT });
    // history.push('/auth');
    // setUser(null);
  };
  const classes = useStyles();
  // let publicUrl = process.env.PUBLIC_URL + "/";
  // let imgattr = "logo";
  // let anchor = "#";
  return (
    <div>
      <div className="navbar-area">
        <nav className="navbar navbar-area navbar-expand-lg">
          <div className="container nav-container">
            <div className="responsive-mobile-menu">
              <button
                className="menu toggle-btn d-block d-lg-none"
                data-toggle="collapse"
                data-target="#realdeal_main_menu"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="icon-left" />
                <span className="icon-right" />
              </button>
            </div>
            <div className="logo readeal-top">
              <Link to="/">
                <img
                  src={"/assets/img/azca-logo-new.png"}
                  // src={
                  //   "http://azca.pk/wp-content/uploads/2020/02/AZCA-Logo-Trans-LBG-2.png"
                  // }
                  width="150"
                  height="150"
                  alt="logo"
                />
              </Link>
            </div>
            <div className="nav-right-part nav-right-part-mobile">
              {auth.status ? (
                <div className={classes.profile}>
                  {/* <Typography className={classes.userName} variant="h6">
                    {user?.result.name}
                  </Typography> */}
                  <Button
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={handleClick}
                  >
                    <Avatar
                      className={classes.purple}
                      alt={user?.result?.name}
                      src={user?.result?.imageUrl}
                    >
                      {user?.result?.name.charAt(0)}
                    </Avatar>
                  </Button>
                  <Menu
                    className={classes.Menu}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                    elevation={0}
                    getContentAnchorEl={null}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleCloseMenu}
                  >
                    <MenuItem
                      onClick={() => {
                        history.push("/dashboard");
                        handleCloseMenu();
                      }}
                    >
                      Dasboard
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        handleShow();
                        handleCloseMenu();
                      }}
                    >
                      Logout
                    </MenuItem>
                  </Menu>
                  {/* <Button
                    variant="contained"
                    className={classes.logout}
                    color="secondary"
                    onClick={logout}
                  >
                    Logout
                  </Button> */}
                </div>
              ) : (
                <Link className="btn btn-yellow" to="/login">
                  Login / signup
                  {/* <span className="right">
                  <i className="la la-plus" />
                </span> */}
                </Link>
              )}
            </div>
            <div className="collapse navbar-collapse" id="realdeal_main_menu">
              <ul className="navbar-nav menu-open readeal-top text">
                <li
                //className="menu-item-has-children current-menu-item"
                >
                  <a href="/">Home</a>
                  {/* <ul className="sub-menu ">
                      <li>
                        <Link to="/">Home 01</Link>
                      </li>
                      <li>
                        <Link to="/home-v2">Home 02</Link>
                      </li>
                      <li>
                        <Link to="/home-v3">Home 03</Link>
                      </li>
                      <li>
                        <Link to="/home-v4">Home 04</Link>
                      </li>
                    </ul> */}
                </li>
                <li>
                  <Link to="/About">About us</Link>
                </li>

                {/* <li>
                  <Link to="/">Our Projects </Link>
                </li> */}

                {/* <li>
                  <Link to="/project1">Our Projects</Link>
                </li> */}

                <li className="menu-item-has-children">
                  <a href="/project1">Our Projects</a>
                  <ul className="sub-menu">
                    <li>
                      {myProjects?.map((project) => (
                        <Link
                          to={{
                            pathname: `/project1`,
                            search: "?id=" + project.sys.id,
                            state: {
                              arrayNumber: project.sys.id,
                            },
                          }}
                        >
                          {project.fields.title}
                        </Link>
                      ))}
                      {/* <Link
                        to={{
                          pathname: '/project1',
                          state: {
                            arrayNumber: Project,
                          },
                        }}
                      >
                        Project 1
                      </Link> */}
                    </li>
                  </ul>
                </li>

                {/* <li>
                  <Link to="/search-map">Find a Property</Link>
                </li> */}
                <li>
                  <Link to="/contact">Contact Us</Link>
                </li>

                {/* <li className="menu-item-has-children">
                    <a href="#">Property</a>
                    <ul className="sub-menu">
                      <li>
                        <Link to="/property">Property</Link>
                      </li>
                      <li>
                        <Link to="/availavbe-property">
                          Propertys Availavbe
                        </Link>
                      </li>
                      <li>
                        <Link to="/properties-by-city">Property By City</Link>
                      </li>
                      <li>
                        <Link to="/recent-properties">Property Recenty</Link>
                      </li>
                      <li>
                        <Link to="/property-details">Property Details</Link>
                      </li>
                    </ul>
                  </li>
                  <li className="menu-item-has-children">
                    <a href="#">Pages</a>
                    <ul className="sub-menu">
                      <li>
                        <Link to="/About">About</Link>
                      </li>
                      <li>
                        <Link to="/advisor">Advisor</Link>
                      </li>
                      <li>
                        <Link to="/search-list">Search List</Link>
                      </li>
                      <li>
                        <Link to="/search-grid">Search Grid</Link>
                      </li>
                      <li>
                        <Link to="/faq">FAQ</Link>
                      </li>
                      <li>
                        <Link to="/pricing">Pricing</Link>
                      </li>
                      <li>
                        <Link to="/user-list">User List</Link>
                      </li>
                      <li>
                        <Link to="/Registration">Registration</Link>
                      </li>
                      <li>
                        <Link to="/error">404</Link>
                      </li>
                    </ul>
                  </li>
                */}
                <li className="menu-item-has-children">
                  <a href="#">Others</a>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/careers">Career</Link>
                    </li>
                    <li>
                      <Link to="/news">Blogs</Link>
                    </li>
                    {/* <li>
                      <Link to="/">Gallery</Link>
                    </li> */}
                    <li>
                      <Link to="/maps">Maps</Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div className="nav-right-part nav-right-part-desktop readeal-top">
              {auth.status ? (
                <div className={classes.profile}>
                  {/* <Typography className={classes.userName} variant="h6">
                    {user?.result.name}
                  </Typography> */}
                  <Button
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={handleClick}
                  >
                    <Avatar
                      className={classes.purple}
                      alt={user?.result?.name}
                      src={user?.result?.imageUrl}
                    >
                      {user?.result?.name.charAt(0)}
                    </Avatar>
                  </Button>
                  <Menu
                    className={classes.Menu}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                    elevation={0}
                    getContentAnchorEl={null}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleCloseMenu}
                  >
                    <MenuItem
                      onClick={() => {
                        history.push("/dashboard");
                        handleCloseMenu();
                      }}
                    >
                      Dasboard
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        handleShow();
                        handleCloseMenu();
                      }}
                    >
                      Logout
                    </MenuItem>
                  </Menu>
                  {/* <Button
                    variant="contained"
                    className={classes.logout}
                    color="secondary"
                    onClick={logout}
                  >
                    Logout
                  </Button> */}
                </div>
              ) : (
                <Link className="btn btn-yellow" to="/login">
                  Login / signup
                </Link>
              )}
            </div>
          </div>
        </nav>
      </div>
      <ConfirmLogout open={open} handleClose={handleClose} />
    </div>
  );
}

export default Navbar;

export const ConfirmLogout = ({ open, handleClose }) => {
  const dispatch = useDispatch();

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Confirm log out</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to log out from AZCA Real estate & builders?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            color="primary"
            style={{ color: "#fda94f" }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              dispatch(logout());
              handleClose();
            }}
            color="primary"
            style={{ color: "#fda94f" }}
            autoFocus
          >
            yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
